// extracted by mini-css-extract-plugin
export var spinner = "Loader-module--spinner--1bDSe";
export var small = "Loader-module--small--7QTTq";
export var xssmall = "Loader-module--xssmall--CcyLj";